// extracted by mini-css-extract-plugin
export var root = "index-module--root--b6575";